import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PENDING_TOAST_KEY = 'ofp_pending_toast_message';

export const toastifyMessage = (message) => {
  const notify = () => toast.info(message);

  return notify();
};

export const queueToastifyMessage = (message) => {
  if (!message) return;
  try {
    localStorage.setItem(PENDING_TOAST_KEY, message);
  } catch (e) {
    // ignore localStorage errors
  }
};

export const consumeQueuedToastifyMessage = () => {
  try {
    const message = localStorage.getItem(PENDING_TOAST_KEY);
    if (message) {
      localStorage.removeItem(PENDING_TOAST_KEY);
    }
    return message || '';
  } catch (e) {
    return '';
  }
};

export const ToastifyContainer = (props) => (
  <ToastContainer {...props} />
);
